$(document).ready(function () {
    let wrapper = $('.notifier__wrapper');

    if (!wrapper.length) return;

    wrapper.addClass('visible');

    let notifications = wrapper.find('.notifier__item')

    notifications.each(function (key, value) {
        $(value).addClass('visible');

        setTimeout(function () {
            $(value).removeClass('visible')
            $(value).animate({opacity: 0}, 400, 'linear', function () {
                $(this).remove()
            })
        }, $(value).data('timeout'));
    })
})

class FlashNotifier {
    constructor(title, config) {
        this.title = title
        this.config = {
            type: 'success',
            timeout: 3000,
        }

        if (config !== undefined) {
            this.config = {...this.config, ...config};
        }

        this.wrapper = this.createWrapper()
        this.notify = this.createNotify()

        this.push()

        this.clear(this.notify)
    }

    createWrapper() {
        let wrapper = $('.notifier__wrapper');

        if (wrapper.length) {
            return wrapper;
        } else {
            return $('<div>', {class: 'notifier__wrapper'}).appendTo('body');
        }
    }

    createNotify() {
        let notify = '<div class="notifier__icon"></div><span>'+this.title+'</span>'

        return $('<div>', {class: 'notifier__item' + ' ' + this.config.type}).append(notify);
    }

    push() {
        this.wrapper.addClass('visible');
    
        this.wrapper.append(this.notify);

        this.notify.addClass('visible');
    }

    clear(notify) {
        setTimeout(function () {
            notify.removeClass('visible')
            notify.animate({opacity: 0}, 400, 'linear', function () {
                $(this).remove()
            })
        }, this.config.timeout);
    }
}

window.flashNotify = function(title, config){
    new FlashNotifier(title, config)
}


